import { render } from "./definitionBuilderTask.vue?vue&type=template&id=c2bffdd8"
import script from "./definitionBuilderTask.vue?vue&type=script&lang=js"
export * from "./definitionBuilderTask.vue?vue&type=script&lang=js"

import "./definitionBuilderTask.vue?vue&type=style&index=0&id=c2bffdd8&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__